import React from 'react';
import PropTypes from 'prop-types';
import {LabelIndex} from '../LabelIndex';
import {OptionFeedback} from '../OptionFeedback';

const CLASS_NAME = {
  CORRECT: 'correct',
  INCORRECT: 'incorrect',
};

/**
 * The option component to be displayed for CSCQ & CSCQ_COLOR [SingeSelect Component]
 */
export function SingleSelectOption(props) {
  const selectOption = (event) => {
    event.preventDefault();
    if (props.disabled === false) {
      props.selectOption({
        componentID: props.componentID,
        optionID: props.id,
        checked: !props.selected,
      });
    }
  };

  const wrapperClass = () => {
    return `${props.className} ${props.disabled ? getFeedbackClassName() : ''}`;
  };

  const getFeedbackClassName = () =>
    props.isCorrect ? CLASS_NAME.CORRECT : CLASS_NAME.INCORRECT;

  return (
    <>
      <div className={wrapperClass()} onClick={selectOption}>
        <LabelIndex
          id={props.id}
          selected={props.selected}
          disabled={props.disabled}
          isCorrect={props.isCorrect}
        />
        {props.children}
      </div>
      <OptionFeedback
        visible={props.disabled}
        type={getFeedbackClassName()}
        text={props.feedback}
      />
    </>
  );
}

SingleSelectOption.propTypes = {
  /**
   * Child components to be displayed in the option
   */
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array])
    .isRequired,
  /**
   * Custom className to be set on component
   */
  className: PropTypes.string,
  /**
   * ComponentID for which the option belongs to
   */
  componentID: PropTypes.number.isRequired,
  /**
   * The feedback to be displayed for the particular option
   */
  feedback: PropTypes.string,
  /**
   * ID for the particular prop
   */
  id: PropTypes.number.isRequired,
  /**
   * Boolean value specifying if the option is correct
   */
  isCorrect: PropTypes.bool.isRequired,
  /**
   * Boolean value specifying if the option is selected
   */
  selected: PropTypes.bool,
  /**
   * Boolean value specifying if the option is disabled
   */
  disabled: PropTypes.bool.isRequired,
  /**
   * Callback function to be involked when selecting the option
   */
  selectOption: PropTypes.func.isRequired,
};

SingleSelectOption.defaultProps = {};
